import axios from '../axios'

/* 
 * 模块启用禁用
 */
//查询
export const getList = (params) => {
  return axios({
      url: '/home/app/module/list',
      method: 'get',
      params
  })
}

//启用 禁用 操作
export const optStatusApi = data => {
  return axios({
      url: '/home/app/module',
      method: 'put',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/api/module.js